/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Announcement bar
*/
const initStickyAnnouncementBar = () => {
    const section = document.querySelector('.announcement-bar-sticky')
    if (!section) return

    section.closest('.shopify-section').classList.add('sticky-top')

    const navbar = document.querySelector('[id*="__navbar"].sticky-top')
    if (!navbar) return

    navbar.style.top = document.querySelector('.announcement-bar-sticky').clientHeight + 'px'
}
initStickyAnnouncementBar()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.announcement-bar-sticky')) {
        initStickyAnnouncementBar()
    }
})

document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.announcement-bar .carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Carousel
*/
document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Marquee
*/
const initMarqueeSections = () => {
    document.querySelectorAll('.marquee').forEach(section => {
        const list = section.querySelector('ul')
        const marqueeWidth = list.scrollWidth
        const marqueeLength = list.querySelectorAll('li').length

        list.insertAdjacentHTML('beforeEnd', list.innerHTML)
        list.insertAdjacentHTML('beforeEnd', list.innerHTML)

        list.querySelectorAll('li').forEach((item, index) => {
            if (index >= marqueeLength) {
                item.setAttribute('aria-hidden', 'true')
            }
        })

        let translateX = `-${marqueeWidth}`

        if (document.documentElement.getAttribute('dir') === 'rtl') {
            translateX = `${marqueeWidth}`
        }

        let style = `
            <style>
                #marquee-${list.dataset.sectionId} ul {
                    animation-name: marquee-animation-${list.dataset.sectionId};
                    animation-duration: ${list.dataset.animationDuration}s;
                }
                @keyframes marquee-animation-${list.dataset.sectionId} {
                    to { transform: translateX(${translateX}px); }
                }
            </style>
        `
        if (list.dataset.marqueeDirection === 'right') {
            style += `
                <style>
                    @keyframes marquee-animation-${list.dataset.sectionId} {
                        from { transform: translateX(${translateX}px); }    
                        to { transform: 0); }    
                    }
                </style>
            `
        }

        list.insertAdjacentHTML('beforeBegin', style)
    })
}
initMarqueeSections()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.marquee')) {
        initMarqueeSections()
    }
})

/*
    Featured Products
*/
const initFeaturedProducts = () => {
    document.querySelectorAll('.featured-products:not(.init)').forEach(section => {
        section.classList.add('init')

        const element = section.querySelector('.splide')

        if (!element) {
            return
        }

        const mySplide = new Splide(element, {
            arrows: element.dataset.arrows === 'true',
            pagination: element.dataset.pagination === 'true',
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: 0 },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            },
            direction: document.documentElement.getAttribute('dir')
        })

        const fixArrowsPos = () => {
            const top = section.querySelector('.product-item-img')?.clientHeight / 2
            section.querySelectorAll('.splide__arrow').forEach(arrow => {
                arrow.style.top = `${top}px`
            })
        }

        const fixPagination = () => {
            if (window.matchMedia('(max-width: 575px').matches) {
                const pagination = section.querySelector('.splide__pagination')

                if (!pagination) return

                section.querySelector('.splide__pagination--mobile')?.remove()

                const total = pagination.querySelectorAll('button').length

                let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
                text = text.replace('[total]', total)

                pagination.insertAdjacentHTML('beforebegin', `
                    <div class="splide__pagination--mobile text-muted small">
                        ${text}
                    </div>
                `)
            }
        }

        mySplide.on('ready resize', () => {
            fixArrowsPos()
            fixPagination()
        })

        mySplide.on('move', () => {
            fixPagination()
        })

        mySplide.mount()
    })
}
initFeaturedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initFeaturedProducts()
    }
})

/*
    Recommended Products
    https://shopify.dev/themes/product-merchandising/recommendations
*/
const initRecommendedProducts = async () => {
    const section = document.querySelector('.recommended-products')

    if (!section) return

    const { sectionId, baseUrl, productId, limit, intent } = section.dataset
    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
    const response = await fetch(url)
    const data = await response.text()

    section.closest('.shopify-section').outerHTML = data

    document.querySelectorAll('.recommended-products [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    initFeaturedProducts()

    const customEvent = new CustomEvent('init.ecomify.recommended_products')
    window.dispatchEvent(customEvent)
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})

/*
    Testimonials
*/
const initTestimonials = () => {
    document.querySelectorAll('.testimonials').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            type: element.dataset.loop === 'true' ? 'loop' : 'slide',
            arrows: element.dataset.arrows === 'true',
            pagination: element.dataset.pagination === 'true',
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '10%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            },
            direction: document.documentElement.getAttribute('dir')
        })

        const fixArrowsPos = () => {
            const top = section.querySelector('.card').clientHeight / 2
            section.querySelectorAll('.splide__arrow').forEach(arrow => {
                arrow.style.top = `${top}px`
            })
        }

        const fixPagination = () => {
            if (window.matchMedia('(max-width: 575px').matches) {
                const pagination = section.querySelector('.splide__pagination')

                if (!pagination) return

                section.querySelector('.splide__pagination--mobile')?.remove()

                const total = pagination.querySelectorAll('button').length

                let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
                text = text.replace('[total]', total)

                pagination.insertAdjacentHTML('beforebegin', `
                    <div class="splide__pagination--mobile text-muted small">
                        ${text}
                    </div>
                `)
            }
        }

        mySplide.on('ready resize', () => {
            fixArrowsPos()
            fixPagination()
        })

        mySplide.on('move', () => {
            fixPagination()
        })

        mySplide.mount()
    })
}
initTestimonials()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.testimonials')) {
        initTestimonials()
    }
})

/*
    Parallax image
*/
const initParallaxImage = () => {
    document.querySelectorAll('.parallax-image').forEach(async (section, index) => {
        if (index === 0) {
            const vendorScript = document.createElement('script')
            vendorScript.src = section.dataset.vendorScript
            document.head.appendChild(vendorScript)

            await new Promise(resolve => setTimeout(resolve, 1000))
        }

        const imgMobile = section.querySelector('.img-mobile')
        const imgDesktop = section.querySelector('.img-desktop')

        if (!imgMobile || !imgDesktop) return

        // eslint-disable-next-line new-cap, no-new
        new simpleParallax(imgMobile, {
            orientation: imgMobile.dataset.orientation,
            scale: Number(imgMobile.dataset.scale / 100)
            // maxTransition: 80
        })

        // eslint-disable-next-line new-cap, no-new
        new simpleParallax(imgDesktop, {
            orientation: imgDesktop.dataset.orientation,
            scale: Number(imgDesktop.dataset.scale / 100)
        })
    })
}
initParallaxImage()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-image')) {
        initParallaxImage()
    }
})



const initL4VTopbarBreakpointSync = () => {
    const resizeKey = 'l4vTopbarBreakpointSyncBound'

    const getHeaderRoot = () => {
        return document.querySelector('.shopify-section-group-header-group') || document
    }

    const getSections = (selector) => {
        const root = getHeaderRoot()
        const scoped = [...root.querySelectorAll(selector)]
        if (scoped.length) return scoped
        return [...document.querySelectorAll(selector)]
    }

    const applyVisibility = (elements, visible, innerSelector, innerDisplay) => {
        elements.forEach((element) => {
            if (!element) return
            element.style.display = visible ? 'block' : 'none'
            element.style.visibility = visible ? 'visible' : 'hidden'
            element.style.opacity = visible ? '1' : '0'

            const inner = element.matches(innerSelector) ? element : element.querySelector(innerSelector)
            if (inner) {
                inner.style.display = visible ? innerDisplay : 'none'
                inner.style.visibility = visible ? 'visible' : 'hidden'
                inner.style.opacity = visible ? '1' : '0'
            }
        })
    }

    const sync = () => {
        const marqueeSections = getSections("section[id*='__marquee'].shopify-section, [id*='__marquee'].shopify-section, section[id^='marquee-']")
        const announcementSections = getSections("section[id*='__announcement-bar'].shopify-section, [id*='__announcement-bar'].shopify-section, section[id^='announcement-bar-']")
        const showMarquee = window.innerWidth < 992

        applyVisibility(marqueeSections, showMarquee, '.marquee', 'block')
        applyVisibility(announcementSections, !showMarquee, '.announcement-bar', 'flex')
    }

    sync()

    if (!window[resizeKey]) {
        window.addEventListener('resize', sync)
        document.addEventListener('shopify:section:load', sync)
        window[resizeKey] = true
    }
}

/*
  L4V page cart freeze
  - Freeze visible topbar + navbar before offcanvas cart opens
  - Applies to contact + over-ons page templates
  - Also freezes page scroll position so background does not jump
*/
const initL4VContactCartFreeze = () => {
    const body = document.body
    if (!body || !body.classList.contains('page-type-page')) return

    const cart = document.querySelector('#offcanvas-cart')
    if (!cart) return

    const getVisible = (selectors) => {
        return [...document.querySelectorAll(selectors)].find(el => {
            const st = window.getComputedStyle(el)
            return st.display !== 'none' && st.visibility !== 'hidden' && el.getBoundingClientRect().height > 0
        }) || null
    }

    const cleanup = () => {
        body.classList.remove('l4v-cart-open-freeze')
        document.documentElement.style.removeProperty('--l4v-cart-topbar-h')
        document.body.style.paddingRight = ''

        document.documentElement.querySelectorAll('.l4v-cart-freeze-topbar, .l4v-cart-freeze-navbar, .l4v-cart-origin-hidden').forEach(el => {
            el.classList.remove('l4v-cart-freeze-topbar', 'l4v-cart-freeze-navbar', 'l4v-cart-origin-hidden')
            el.style.removeProperty('margin-right')
        })

        document.querySelectorAll('#l4v-cart-header-overlay').forEach(el => el.remove())
    }

    const sanitizeTopbarClone = (clone, source) => {
        if (!clone) return

        clone.querySelectorAll('.animate__animated, .opacity-0').forEach(el => {
            el.classList.remove('animate__animated', 'opacity-0')
            el.style.removeProperty('animation-delay')
        })

        const sourceCarousel = source ? source.querySelector('.announcement-bar .carousel') : null
        const cloneCarousel = clone.querySelector('.announcement-bar .carousel')

        if (cloneCarousel) {
            cloneCarousel.removeAttribute('id')
            cloneCarousel.querySelectorAll('.carousel-control, .carousel-indicators, [data-bs-slide], [data-bs-target]').forEach(el => el.remove())

            const sourceItems = sourceCarousel ? [...sourceCarousel.querySelectorAll('.carousel-item')] : []
            let activeIndex = sourceItems.findIndex(item => item.classList.contains('active'))
            if (activeIndex < 0) activeIndex = 0

            const intervalAttr = sourceCarousel ? sourceCarousel.getAttribute('data-bs-interval') : null
            const sourceRide = sourceCarousel ? sourceCarousel.getAttribute('data-bs-ride') : null
            const autoplayEnabled = sourceRide === 'carousel'
            const interval = intervalAttr ? parseInt(intervalAttr, 10) : 5000

            cloneCarousel.querySelectorAll('.carousel-item').forEach((item, index) => {
                item.classList.toggle('active', index === activeIndex)
                item.style.removeProperty('display')
                item.style.removeProperty('transform')
                item.style.removeProperty('transition')
            })

            if (window.bootstrap && typeof window.bootstrap.Carousel === 'function') {
                try {
                    const instance = window.bootstrap.Carousel.getOrCreateInstance(cloneCarousel, {
                        interval: Number.isFinite(interval) && interval > 0 ? interval : 5000,
                        ride: false,
                        pause: false,
                        touch: false,
                        wrap: true
                    })
                    instance.to(activeIndex)
                    if (autoplayEnabled) {
                        window.setTimeout(() => {
                            instance.cycle()
                        }, 180)
                    } else {
                        instance.pause()
                    }
                } catch (error) {
                    console.warn('L4V clone carousel init skipped', error)
                }
            }
        }

        const cloneMarquee = clone.querySelector('.marquee ul')
        if (cloneMarquee) {
            cloneMarquee.style.animationPlayState = 'paused'
        }
    }

    const freeze = () => {
        const marqueeSection = getVisible("section[id*='__marquee'].shopify-section, [id*='__marquee'].shopify-section")
        const announcementSection = getVisible("section[id*='__announcement-bar'].shopify-section, [id*='__announcement-bar'].shopify-section")
        const navbarSection = getVisible("section[id*='__navbar'].shopify-section, [id*='__navbar'].shopify-section")

        const topbarSection = window.innerWidth < 992 ? (marqueeSection || announcementSection) : (announcementSection || marqueeSection)
        const topbarHeight = topbarSection ? Math.round(topbarSection.getBoundingClientRect().height || 0) : 0

        cleanup()

        if (topbarSection) {
            topbarSection.classList.add('l4v-cart-origin-hidden')
        }
        if (navbarSection) {
            navbarSection.classList.add('l4v-cart-origin-hidden')
        }

        const overlay = document.createElement('div')
        overlay.id = 'l4v-cart-header-overlay'

        if (topbarSection) {
            const topbarClone = topbarSection.cloneNode(true)
            topbarClone.classList.remove('l4v-cart-origin-hidden')
            topbarClone.querySelectorAll('.l4v-cart-origin-hidden').forEach(el => el.classList.remove('l4v-cart-origin-hidden'))
            topbarClone.classList.add('l4v-cart-overlay-topbar')
            sanitizeTopbarClone(topbarClone, topbarSection)
            overlay.appendChild(topbarClone)
        }

        if (navbarSection) {
            const navbarClone = navbarSection.cloneNode(true)
            navbarClone.classList.remove('l4v-cart-origin-hidden')
            navbarClone.querySelectorAll('.l4v-cart-origin-hidden').forEach(el => el.classList.remove('l4v-cart-origin-hidden'))
            navbarClone.classList.add('l4v-cart-overlay-navbar')
            overlay.appendChild(navbarClone)
        }

        document.body.appendChild(overlay)

        document.documentElement.style.setProperty('--l4v-cart-topbar-h', topbarHeight + 'px')
        document.body.style.paddingRight = '0px'
        body.classList.add('l4v-cart-open-freeze')
    }

    // pre-open: do this on the cart trigger click in capture phase, before bootstrap animates
    document.querySelectorAll('a[href="#offcanvas-cart"][data-bs-toggle="offcanvas"], [data-bs-target="#offcanvas-cart"]').forEach(trigger => {
        if (trigger.dataset.l4vCartFreezeInit === 'true') return
        trigger.dataset.l4vCartFreezeInit = 'true'
        trigger.addEventListener('click', () => {
            freeze()
        }, true)
    })

    cart.addEventListener('show.bs.offcanvas', freeze)
    cart.addEventListener('shown.bs.offcanvas', () => {
        freeze()
    })
    cart.addEventListener('hidden.bs.offcanvas', cleanup)
    window.addEventListener('resize', () => {
        if (cart.classList.contains('show')) freeze()
    })
}

initL4VTopbarBreakpointSync()
initL4VContactCartFreeze()
document.addEventListener('shopify:section:load', initL4VContactCartFreeze)

/*
  L4V initial-load stabilization
  - Re-run the same header/cart sync after late browser layout events
*/
const runL4VHeaderStabilizers = () => {
    try { initStickyAnnouncementBar() } catch (e) {}
    try { initL4VTopbarBreakpointSync() } catch (e) {}
    try { initL4VContactCartFreeze() } catch (e) {}
}

window.addEventListener('load', () => {
    runL4VHeaderStabilizers()
    window.requestAnimationFrame(runL4VHeaderStabilizers)
    window.setTimeout(runL4VHeaderStabilizers, 120)
    window.setTimeout(runL4VHeaderStabilizers, 450)
    window.setTimeout(runL4VHeaderStabilizers, 1200)
})

window.addEventListener('pageshow', runL4VHeaderStabilizers)
window.addEventListener('focus', runL4VHeaderStabilizers)
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) runL4VHeaderStabilizers()
})
